module.exports = __webpack_public_path__ + "static/peekimplant-5eda13abeaf9f1698ba2d761673b44ef.jpeg";